import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=70b8b3d0&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=js&"
export * from "./FileSystem.vue?vue&type=script&lang=js&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=70b8b3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8b3d0",
  null
  
)

export default component.exports